import {getPolishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Оценете статията',
    message: 'Подаден глас',
    votes: votes => `${getPolishPlurals(["мнение", "мнения", "мнения"], +votes)},`,
    score: 'оценка',
  },
  feedback: {
    label: 'Полезна ли е тази статия?'
  }
};
